import { Doughnut } from 'react-chartjs-2';
import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  colors,
  useTheme
} from '@material-ui/core';

const DistributionByCountrys = ({ accountdata, ...rest }) => {
  const theme = useTheme();

  console.log(accountdata)

  let downloadsArray = accountdata.map(el => el.value)
  let procentData = []
  let countriesForDiagram = []
  const diagramcolors = [ { color:  'rgba(29, 102, 179, 0.6)' },{ color: 'rgb(27, 102, 179)' },{color: 'grey'}, {color: '#fce531'},
  { color: '#282c2f' }, { color: '#f50057' }, { color: '#01786F' }, { color: '#576675' },{ color: '#24bced' }, {color: '#70757a'}, 
{color: 'red'}];

  if (downloadsArray.length > 0) {
    let amountOfDownloads = downloadsArray.reduce((total = 0, amount = 0) => total + amount)
    procentData = accountdata.map(el => { return { ...el, color: '', downloads: (el.value * 100 / amountOfDownloads) < 1 ? (el.value * 100 / amountOfDownloads).toFixed(1) : (el.value * 100 / amountOfDownloads).toFixed(0)}})
    

    // Create a new array with property 'color'
      diagramcolors.length = procentData.length
      countriesForDiagram = diagramcolors.map((obj, index) => {
      const res = procentData[index];
      res.color = obj.color;
      return res;
    });
  }
  
  countriesForDiagram = countriesForDiagram.filter(el => el.value !== "0")
  console.log('countriesForDiagram: ', countriesForDiagram)


  const data = {
    labels: countriesForDiagram.map((a) => a.name),
    datasets: [
      {
        data: accountdata.map((c) => c.value),
        backgroundColor: countriesForDiagram.map((c) => c.color),
        borderWidth: 1,
        hoverBorderColor: colors.common.white,
      }
    ],
    labels: accountdata.map((c) => c.name)
  };

  const options = {
    animation: true,
    cutoutPercentage: 80,
    layout: { padding: 0 },
    plugins: {
      legend: {
        display: true,
        labels: {
          usePointStyle: false,
        },
        title: {
          display: true
        },
      },
    },

    maintainAspectRatio: false,
    responsive: true,
    aspectRatio: 2,
    tooltips: {
      backgroundColor: theme.palette.background.paper,
      bodyFontColor: theme.palette.text.secondary,
      borderColor: theme.palette.divider,
      borderWidth: 1,
      enabled: true,
      footerFontColor: theme.palette.text.secondary,
      intersect: false,
      mode: 'index',
      titleFontColor: theme.palette.text.primary
    }
  };

  return (
    <Card {...rest}>
      <CardHeader title="Kunden Verteilung" />
      <Divider />
      <CardContent>
        <Box
          sx={{
            height: 300,
            position: 'relative'
          }}
        >
          <Doughnut
            data={data}
            options={options}
          />
        </Box>
        <Box
          sx={{
            marginTop:'100px',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            pt: 2
          }}
        >
          {countriesForDiagram.map(({
            color,
            name,
            value
          }) => (
            <Box
              key={name}
              sx={value !== '0' ? {
                p: 1,
                textAlign: 'center'
              } : {textAlign: 'center'}}
            >
              <Typography
                color={color}
                variant="h4"
              >
                {value !== '0' ? name : '' }
              </Typography>
              <Typography
               style={{ color: '#00264d' }}
                variant="h5"
              >
                {value !== '0' ? `${new Intl.NumberFormat("de-DE").format(Math.round(value))} kWh` : '' }               
              </Typography>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

DistributionByCountrys.propTypes = {
  kundendata: PropTypes.any
};

export default React.memo(DistributionByCountrys);
